import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "./toast.css";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { toast } from "react-toastify";

export const customToast = (type, focus, title, desc) => {
  const Msg = ({ closeToast, titleStyle, descStyle, icon, closeIconStyle }) => {
    return (
      <div
        style={{
          display: "flex",
          alignItem: "flex-start",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div style={{ display: "flex", gap: "12px", width: "90%" }}>
          {icon && icon}
          <div style={{
            display: "flex", gap: "0px", flexDirection: "column", overflowWrap: "break-word", // Handle long words
            wordWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}>
            {title && (
              <span
                className={
                  desc?.length > 0 ? titleStyle + "-large" : titleStyle
                }
              >
                {title}
              </span>
            )}
            {desc && <span className={descStyle + "-large"}>{desc}</span>}
          </div>
        </div>
        <CloseIcon
          onClick={closeToast}
          className={
            desc?.length > 0 ? closeIconStyle + "-large" : closeIconStyle
          }
          style={{ height: "20px", width: "20px", cursor: "pointer" }}
        />
      </div>
    );
  };

  const createToast = (style, icon) => {
    toast.dismiss();
    return (
      title &&
      toast(
        <Msg
          icon={icon}
          titleStyle={style + "-title"}
          descStyle={style + "-desc"}
          closeIconStyle={style + "-icon"}
        />,
        {
          className: style,
          hideProgressBar: true,
          closeButton: false,
        }
      )
    );
  };

  switch (type) {
    case "error":
      switch (focus) {
        case "low":
          createToast(
            "error-low",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(225, 33, 33, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "error-medium",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(225, 33, 33, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "error-high",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "#fff",
              }}
            />
          );
          break;
      }
      break;
    case "success":
      switch (focus) {
        case "low":
          createToast(
            "success-low",
            <CheckCircleIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(1, 153, 57, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "success-medium",
            <CheckCircleIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(1, 153, 57, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "success-high",
            <CheckCircleIcon
              style={{
                height: "22px",
                width: "22px",
                color: "#fff",
              }}
            />
          );
          break;
      }
      break;
    case "warning":
      switch (focus) {
        case "low":
          createToast(
            "warning-low",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(236, 152, 12, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "warning-medium",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(236, 152, 12, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "warning-high",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "#fff",
              }}
            />
          );
          break;
      }
      break;
    case "accent":
      switch (focus) {
        case "low":
          createToast(
            "accent-low",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(64, 62, 159, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "accent-medium",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(64, 62, 159, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "accent-high",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "#fff",
              }}
            />
          );
          break;
      }
      break;
    case "neutral":
      switch (focus) {
        case "low":
          createToast(
            "neutral-low",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(10, 9, 11, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "neutral-medium",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(10, 9, 11, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "neutral-high",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(10, 9, 11, 1)",
              }}
            />
          );
          break;
      }
      break;
    case "black":
      switch (focus) {
        case "low":
          createToast(
            "black-low",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(79, 77, 85, 1)",
              }}
            />
          );
          break;
        case "medium":
          createToast(
            "black-medium",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "rgba(79, 77, 85, 1)",
              }}
            />
          );
          break;
        case "high":
          createToast(
            "black-high",
            <ErrorIcon
              style={{
                height: "22px",
                width: "22px",
                color: "#fff",
              }}
            />
          );
          break;
      }
      break;
    default:
      createToast(
        "neutral-low",
        <ErrorIcon
          style={{
            height: "22px",
            width: "22px",
            color: "rgba(10, 9, 11, 1)",
          }}
        />
      );
  }
};
